const radii = {
  sm: '4px',
  md: '6px',
  lg: '8px',
  full: '9999px',
};

export default radii;
